import React from "react";
import "./style.css";
import { getFormattedAge } from "../../../../../../helper";
import { useSelector } from "react-redux";

const SingleCaseDetails = ({ caseDetails }) => {
  const { countriesList = [] } = useSelector((state) => state.general);
  const isAm = caseDetails?.case_type == "am";

  const subjectInformation = [
    {
      id: 1,
      key: isAm ? "Full Name" : "Temporary Identifier",
      value: isAm ? caseDetails?.full_name : caseDetails?.temporary_identifier,
    },
    {
      id: 12,
      key: "Nationality",
      value:
        caseDetails?.nationality?.nice_name ||
        countriesList.find((item) => item.id == caseDetails?.nationality_id)
          ?.nice_name ||
        "Unknown",
    },
    ...(isAm
      ? [
          {
            id: 12,
            key: "Stated Age",
            value: getFormattedAge(caseDetails),
          },
        ]
      : []),
    ...(!isAm
      ? [
          {
            id: 16,
            key: "Estimated Age Range",
            value: getFormattedAge(caseDetails),
          },
        ]
      : []),
    ...(isAm
      ? [
          {
            id: 16,
            key: "Date of Record",
            value: caseDetails?.date_of_records,
          },
        ]
      : []),
    {
      id: 13,
      key: isAm ? "Indentity Type" : "Date of Accident",
      value: isAm ? caseDetails?.identity_type : caseDetails?.date_of_accident,
    },
    ...(!isAm
      ? [
          {
            id: 12,
            key: "Accident Description",
            value: caseDetails?.accident_description,
          },
        ]
      : []),
    ...(!isAm
      ? [
          {
            id: 12,
            key: "Location of Recovery",
            value: caseDetails?.location_of_recovery,
          },
        ]
      : []),
    ...(isAm
      ? [
          {
            id: 12,
            key: "Indentity Number",
            value: caseDetails?.identity_code,
          },
        ]
      : []),

    {
      id: 1,
      key: "Gender",
      value: caseDetails?.gender,
    },

    {
      id: 13,
      key: "Ethnicity",
      value: caseDetails?.ethnicity,
    },

    {
      id: 14,
      key: "Medical & Identifying Marks",
      value: caseDetails?.medical_history,
    },
  ];

  const clinicalEvaluation = [
    {
      id: 1,
      key: "Gender",
      value: caseDetails?.gender,
    },

    {
      id: 13,
      key: "Ethnicity",
      value: caseDetails?.ethnicity,
    },
    ...(!isAm
      ? [
          {
            id: 16,
            key: "Estimated Age",
            value: caseDetails?.estimated_age,
          },
        ]
      : []),

    {
      id: 14,
      key: "Medical & Identifying Marks",
      value: caseDetails?.medical_history,
    },
  ];

  return (
    <div className="d-case_details_container">
      <p className="d-case_details_case_number">
        Case Number : {caseDetails?.case_number}
      </p>
      <div className="case_details_body">
        <div className="case_details_header">
          <p>
            {isAm
              ? "Ante-Mortem Case Information"
              : "Post-Mortem Case Information"}
          </p>
        </div>
        {subjectInformation.map((item, index) => {
          return (
            <div className="case_details_item" key={index}>
              <div className="left_section">
                <p className="left_section_key">{item.key}</p>
              </div>
              <div className="right_section">
                <p className="right_section_value">{item.value}</p>
              </div>
            </div>
          );
        })}
      </div>
      {/* <div className="case_details_body">
        <div className="case_details_header">
          <p>Clinical Evaluation</p>
        </div>
        {clinicalEvaluation.map((item, index) => {
          return (
            <div className="case_details_item" key={index}>
              <div className="left_section">
                <p className="left_section_key">{item.key}</p>
              </div>
              <div className="right_section">
                <p className="right_section_value">{item.value}</p>
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

export default SingleCaseDetails;
